// src/features/inventory/services/suppliers.js
import { apiClient } from '../../../services/api/client';

export const suppliersAPI = {
  getAll: () =>
    apiClient.get('/api/v1/inventory/suppliers/'),

  getById: (supplierId) =>
    apiClient.get(`/api/v1/inventory/suppliers/${supplierId}`),

  getForItem: (itemId) =>
    apiClient.get(`/api/v1/inventory/suppliers/?item_id=${itemId}`),

  create: ({ code, name, contact_email, contact_phone, address }) =>
    apiClient.post('/api/v1/inventory/suppliers/', {
      code,
      name,
      contact_email: contact_email || null,
      contact_phone: contact_phone || null,
      address: address || null,
    }),

  update: (supplierId, { name, contact_email, contact_phone, address, active }) =>
    apiClient.put(`/api/v1/inventory/suppliers/${supplierId}`, {
      name: name ?? null,
      contact_email: contact_email ?? null,
      contact_phone: contact_phone ?? null,
      address: address ?? null,
      active: active ?? null,
    }),

  remove: (supplierId) =>
    apiClient.delete(`/api/v1/inventory/suppliers/${supplierId}`),

  linkItem: (supplierId, { item_id, supplier_item_number, barcode, sort_order = 0 }) =>
    apiClient.post(`/api/v1/inventory/suppliers/${supplierId}/items`, {
      item_id,
      supplier_item_number: supplier_item_number || null,
      barcode: barcode || null,
      sort_order,
    }),
};
